/* eslint-disable no-unused-vars */
/* eslint-disable no-inner-declarations */

// import Swiper from 'Vendor/swiper.js';
import $ from "jquery";

import Swiper, { Navigation, Pagination } from 'swiper';

const flipCards = document.querySelector('[data-js="flip-cards"]');

let swiperProductModal = undefined;

export default function productModalSlider() {
    if (!$(".product-slider").length) return;

    // When Carousel exists
    if (productModalSlider) {
        function initProductModalSlider() {
            let $obj = $('.product-slider');

            const swiperCarousels = document.querySelectorAll(".product-swiper");

            swiperCarousels.forEach(carouselContainer => {
                let $this = $(carouselContainer);

                const carouselPagination = carouselContainer.querySelector(
                    ".swiper-pagination"
                );

                const carouselPrevButton =
                    carouselContainer.querySelector(".swiper-button-prev") ||
                    carouselContainer.parentElement.querySelector(
                        ".swiper-button-prev" // <-- this is how you can have the Prev Button outside the swiper container
                    );

                const carouselNextButton =
                    carouselContainer.querySelector(".swiper-button-next") ||
                    carouselContainer.parentElement.querySelector(
                        ".swiper-button-next" // <-- this is how you can have the Next Button outside the swiper container
                    );

                if (!$this.hasClass('swiper-horizontal')) {
                    swiperProductModal = new Swiper(carouselContainer, {
                        modules: [Navigation, Pagination],
                        loop: true,
                        spaceBetween: 10,
                        centeredSlides: true,
                        grabCursor: true,
                        slideToClickedSlide: true,
                        slidesPerView: 1.2,
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 10,
                        },
                        navigation: {
                            nextEl: carouselNextButton,
                            prevEl: carouselPrevButton
                        },
                        pagination: {
                            el: carouselPagination,
                            clickable: true,
                            dynamicBullets: true
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: 2,
                                spaceBetween: 15,
                                centeredSlides: true
                            },
                            991: {
                                slidesPerView: 3,
                                spaceBetween: 15,
                                centeredSlides: true
                            }
                        }
                    });
                }
            });
        }
        initProductModalSlider();
    }
}

if (flipCards) {
    setInterval(function() {
        setRandomClass();
    }, 1500);

    // function productModalSlider($obj, slideInitial) {
    //   if (!$obj.length) return;
    //   $obj.find('.swiper-container').each(function(index, element) {
    //     let $this = $(this);

    //     if (!$this.hasClass('swiper-container-horizontal')) {
    //       swiperProductModal = new Swiper(this, {
    //         loop: true,
    //         speed: 500,
    //         spaceBetween: 10,
    //         centeredSlides: true,
    //         grabCursor: true,
    //         slideToClickedSlide: true,
    //         slidesPerView: 1.2,
    //         lazy: {
    //           loadPrevNext: true,
    //           loadPrevNextAmount: 10,
    //         },
    //         navigation: {
    //           nextEl: $this.closest($obj).find('.swiper-button-next'),
    //           prevEl: $this.closest($obj).find('.swiper-button-prev'),
    //         },
    //         pagination: {
    //           el: '.swiper-pagination',
    //           type: 'bullets',
    //           dynamicBullets: true,
    //           clickable: true
    //         },
    //         breakpoints: {
    //           767: {
    //             slidesPerView: 2,
    //             spaceBetween: 15,
    //             centeredSlides: true
    //           },
    //           991: {
    //             slidesPerView: 3,
    //             spaceBetween: 15,
    //             centeredSlides: true
    //           }
    //         }
    //       });
    //     }

    //   });
    // }

    $('#fcProducts').on('show.bs.modal', function(event) {
        setTimeout(function() {
            if (!$('.product-slider-modal .swiper-container').hasClass('swiper-horizontal')) {
                productModalSlider($('.product-slider-modal'), $(event.relatedTarget).data('product-id'));
            }
        }, 300);
    });


    $('#fcProducts').on('shown.bs.modal', function(event) {
        if ($('.product-slider-modal .swiper-container').hasClass('swiper-horizontal')) {
            swiperProductModal.slideToLoop($(event.relatedTarget).data('product-id'));
        }
    })

    $('.flip-container').on('mouseenter', function() {
        let $this = $(this);

        if (!$this.hasClass('mousehover')) {
            $this.addClass('mousehover');
        }
    });

    $('.flip-container').on('mouseleave', function() {
        let $this = $(this);

        if ($this.hasClass('mousehover')) {
            $this.removeClass('mousehover');
        }
    });

    function setRandomClass() {
        let container = $('[data-js="flip-cards"]');
        let items = container.find('.flip-container');
        let number = items.length;
        let random = 0;

        items.removeClass("hover");

        for (let i = 0; i < 3; i++) {
            random = Math.floor((Math.random() * number));
            items.eq(random).addClass("hover");
        }
    }
}
